module.exports = __webpack_public_path__ + "static/media/storyE_background.693db505.png";


//////////////////
// WEBPACK FOOTER
// ./src/storyE/static/storyE_background.png
// module id = 396
// module chunks = 0